import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AddonDetails as SchemaAddonDetails } from '../schemas/AddonDetails';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Addons
 * @summary Get addon by ID
 */
export const GetAddonContentType = '' as const;
export type GetAddonRequest = void;
export type GetAddonResponses = LinkCommonErrorResponses & {
    /**
     * @description Addon found
     */
    '200': {
        'application/json': SchemaAddonDetails;
    };
    /**
     * @description Addon not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetAddonResponseSuccess = GetAddonResponses['200']['application/json'];
export type GetAddonSearchParams = undefined;
export type GetAddonPathParameters = {
    id: string;
};
export const GetAddonUrl = '/addons/{id}' as const;
export const GetAddonMethod = 'GET' as const;
export const getGetAddonUrl = (params: GetAddonPathParameters) =>
    GetAddonUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetAddonPathParameters) => String(params[param]));
